import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { JwtToken } from '../models/token.model';

@Injectable({
    providedIn: 'root',
})
export class TokenService {
    private token = new BehaviorSubject<any>(null);

    constructor() {
        const token = localStorage.getItem('token');
        if (token) {
            this.token.next(JSON.parse(token) as JwtToken);
        }
    }

    getToken(): Observable<JwtToken> {
        return this.token.asObservable();
    }

    setToken(newValue: any): void {
        localStorage.setItem('token', JSON.stringify(newValue));
        this.token.next(newValue);
    }

    removeToken(): void {
        localStorage.removeItem('token');
        this.token.next(null);
    }
}
